export default "__VITE_ASSET__DGVwW7LK__"